import * as styles from "./AlertDialogBody.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import type { AlertDialogBodyProps } from "./AlertDialog.types";

export function AlertDialogBody({
  className,
  ...props
}: AlertDialogBodyProps): JSX.Element {
  return (
    <div
      data-slot="alert-dialog-body"
      className={clsx(styles.body, className)}
      {...props}
    />
  );
}
